import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import numeral from 'numeral';

import { makeStyles } from '@material-ui/core/styles';

import {
  getHeadObj,
  makeRowColumn,
  converParameters,
  getHost,
  handleCopyClipBoard
} from 'lib/commonLib';
import { showSuccessSnackbar } from 'modules/snackbar';
import { checkPassword } from 'lib/api/auth';
import { userOnLogin } from 'lib/api/user';
import { setPortal } from 'modules/portal';
import {
  members,
  deposit,
  chargeBonus,
  chargeBonusEdit,
  chargeBonusDelete,
  chopChange,
  chargeAuthCheck,
  reserveCheck,
} from 'lib/api/member';
import { paramConverter, Validator } from 'modules/common';

import NewInput from 'components/atoms/NewInput';
import MbButton from 'components/atoms/MbButton';
import MbTooltip from 'components/atoms/MbTooltip';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewRemainingAmountFilter from 'components/molecules/NewRemainingAmountFilter';
import MbTabs from 'components/organisms/MbTabs';
import Modal from 'components/organisms/NewModal';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import NewCategoryFilter from 'components/organisms/NewCategoryFilter';

import MainTemplate from 'pages/templates/MainTemplate';

import MainContentTemplate from '../../templates/MainContentTemplate';

import ChargeBox from './ChargeBox';

const usersStyles = makeStyles((theme) => ({
  changeButton: { float: 'right' },
  outlined: {
    borderColor: theme.palette.icon.default,
    backgroundColor: '#fff',
  },
}));

const UserList = () => {
  const classes = usersStyles();
  const dispatch = useDispatch();
  const { portal, user, agencyMenus, sindyMenus } = useSelector(
    ({ portal, auth, common }) => ({
      portal: portal,
      user: auth.user,
      agencyMenus: common.agencyMenus,
      contactMenus: common.contactMenus,
      sindyMenus: common.sindyMenus,
    })
  );
  let newAgencyMenus = [...agencyMenus];
  let newSindyMenus = [...sindyMenus];

  newAgencyMenus[0] = { ...newAgencyMenus[0], USER_ID: 'all' };
  newSindyMenus[0] = { ...newSindyMenus[0], USER_ID: 'all' };

  const { t } = useTranslation();
  const initParam = {
    gubun: 'all',
    pid: 'all',
    userId: 'all',
    contact: 'all',
    eventState: 'all',
    advrtsAmtSdate: moment().format('YYYYMM01'),
    advrtsAmtEdate: moment().format('YYYYMMDD'),
    sDate:
      moment().date() === 1
        ? moment().add(-1, 'day').format('YYYYMMDD')
        : moment().format('YYYYMM01'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    shopFlag: 'all',
    order: 'JOIN_DATE',
    sort: 'desc',
    keyword: '',
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParam);
  const [tempParams, setTempParams] = useState(initParam);
  const [reFetch, setReFetch] = useState(false);
  const [addColumnList, setAddColumnList] = useState(new Map());
  const [customized, setCustomized] = useState({});
  const initError = {
    userId: false,
    payPoint: false,
    name: false,
    date: false,
  };
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  const initModal = {
    open: false,
    type: null,
    params: {},
    data: [],
  };
  const [modal, setModal] = useState(initModal);
  const [deleteParam, setDeleteParam] = useState();
  const [reloadEdit, setReloadEdit] = useState(false);
  const [modalEventType, setModalEventType] = useState('delete');

  const [tableListCount, setTableListCount] = useState({
    adverCnt: 0,
    totalAdverCnt: 0,
  });

  useEffect(() => {
    handleSetAddColumn(params);
    handleCustomized(params);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setInitialization(false);
    setReFetch(false);
  }, [params, reFetch]);

  // 화면에서 추가될 컬럼
  const handleSetAddColumn = (propsParams) => {
    const result = new Map();
    result.set(0, {
      id: 'INFO_MANAGE_ICONS',
      label: t('정보관리'),
      align: 'center',
      makeRowFunc: (rowObj) => {
        const {
          // 사용자로 로그인
          ADVER_LINK_BUTTON = 'N',
          // 회원정보수정
          MODIFY_LINK_BUTTON = 'N',
          // 충전 관리
          CHARGE_BUTTON = 'N',
          // 삭제
          // DELETE_BUTTON = 'N',
        } = rowObj;
        const modifyShowWindowUrl = converParameters({
          url: getHost() + '/ad/member_write.html',
          uid: rowObj['USER_ID'],
          type: 'admin',
        });

        return (
          <TableBtnWrap>
            {ADVER_LINK_BUTTON === 'Y' && propsParams.shopFlag !== '1' && (
              <NewButton
                title={t('광고주 로그인')}
                icon="faUserLock"
                iconBtn
                onClick={(e) => handleModalOpen(rowObj, 'rePassword')}
                disableRipple
              />
            )}
            {MODIFY_LINK_BUTTON === 'Y' && propsParams.shopFlag !== '1' && (
              <NewButton
                title={t('회원정보수정')}
                icon="faEdit"
                iconBtn
                onClick={(e) =>
                  handleOnLogin(rowObj, modifyShowWindowUrl, 'admin')
                }
                disableRipple
              />
            )}
            {CHARGE_BUTTON === 'Y' && (
              <MbTooltip title={t('충전 관리')}>
                <MbButton
                  iconBtn
                  icon="faCoins"
                  onClick={(e) => handleModalOpen(rowObj, 'charge')}
                />
              </MbTooltip>
            )}
            {propsParams.shopFlag === '1' && (
              <NewButton
                title={t('계정 수정')}
                icon="faEdit"
                iconBtn
                onClick={(e) =>
                    handleOnLogin(rowObj, modifyShowWindowUrl, 'admin')
                }
                disableRipple
              />
            )}
          </TableBtnWrap>
        );
      },
    });
    setAddColumnList(result);
  };

  const handleCustomized = (propsParams) => {
    const newIsShopFlag = propsParams.shopFlag === '1';

    // 사용자 구분 광고주 제외 금액 노출 제한 key
    const onPrice = propsParams.gubun === '11';

    // 사용자 구분 메체 key
    const onGrade = propsParams.gubun === '13';

    // 카테고리 선택시 충전관리 및 테이블 필드 변경에 대한 key
    const ctgrSeq = !!propsParams.ctgrSeq;

    const newCustomized = {
      INFO_MANAGE_ICONS: { bodyStyle: { width: 100 } },
      JOIN_DATE: {
        makeBody: (rowObj, headsMap) => {
          const joinDate = rowObj['JOIN_DATE'] != undefined ? rowObj['JOIN_DATE'].split(' ') : [];
          return (
              <>
                {joinDate[0]}
                <br />
                {joinDate[1]}
              </>
          );
        },
      },
      EVENT_STATE_STR: {
        makeBody: (rowObj, headsMap) => {
          return (
            <>
              { rowObj['EVENT_STATE'] === '01' ? (
                  <span style={{ color: '#79bd2f' }}>{rowObj['EVENT_STATE_STR']}</span>
              ) : (
                  <span style={{ color: '#ff0000' }}>{rowObj['EVENT_STATE_STR']}</span>
              )}
            </>
          );
        },
        orderFlag: false,
      },
      CONTACT_NAME: { merged: newIsShopFlag, orderFlag: false },
      CORP_NAME: {
        makeHead: (headsMap) => {
          return `${getHeadObj(headsMap, 'CORP_NAME').label} / ${getHeadObj(headsMap, 'CORP_CONTACT_NAME').label} / ${getHeadObj(headsMap, 'CELLULAR_PHONE').label}`;
        },
        makeBody: (rowObj, headsMap) => {
          const corpName = getHeadObj(headsMap, 'CORP_NAME');
          const name = getHeadObj(headsMap, 'CORP_CONTACT_NAME');
          const phone = getHeadObj(headsMap, 'CELLULAR_PHONE');
          return (
            <>
              <div className="mb-corpName-text" title={rowObj['CORP_NAME']}>
                <b style={{ color: '#0072bc' }}>
                  {makeRowColumn(
                    rowObj['CORP_NAME'],
                    corpName.type,
                    corpName.format
                  )}
                </b>
                {!!rowObj['CORP_CONTACT_NAME'] && (
                  <>
                    <br />
                    <b>
                    {makeRowColumn(
                      rowObj['CORP_CONTACT_NAME'],
                      name.type,
                      name.format
                    )}
                    </b>
                  </>
                )}
                &nbsp;
                {!!rowObj['CELLULAR_PHONE'] && (
                    <>
                      {makeRowColumn(
                          rowObj['CELLULAR_PHONE'],
                          phone.type,
                          phone.format
                      )}
                    </>
                )}
              </div>
            </>
          );
        },
        orderFlag: false,
      },
      CORP_CONTACT_NAME: { merged: true },
      CELLULAR_PHONE: { merged: true },
      PNAME: {
        makeBody: (rowObj, headsMap) => {
          return rowObj['PNAME'];
        },
        orderFlag: false,
      },
      USER_ID: {
        makeBody: (rowObj, headsMap) => {
          return rowObj['USER_ID'];
        },
        orderFlag: false,
      },
      CTGR_NM: { merged: newIsShopFlag || ctgrSeq },
      GENDER: { merged: newIsShopFlag || ctgrSeq },
      AGE_RANGE: { merged: newIsShopFlag || ctgrSeq },
      SCRT_VER_STR: { merged: newIsShopFlag || ctgrSeq },
      MEMBER_POINT: {
        makeBody: (rowObj, headsMap) => {
          const memberPoint = getHeadObj(headsMap, 'MEMBER_POINT');
          return (
            <b style={{ color: '#f00' }}>
              {makeRowColumn(
                rowObj['MEMBER_POINT'],
                memberPoint.type,
                memberPoint.format
              )}
            </b>
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      PAID_POINT: {
        makeBody: (rowObj, headsMap) => {
          const usedPoint = getHeadObj(headsMap, 'PAID_POINT');
          return (
              <b style={{ color: '#f00' }}>
                {makeRowColumn(
                    rowObj['PAID_POINT'],
                    usedPoint.type,
                    usedPoint.format
                )}
              </b>
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      FREE_POINT: {
        makeBody: (rowObj, headsMap) => {
          const usedPoint = getHeadObj(headsMap, 'FREE_POINT');
          return (
              <b style={{ color: '#f00' }}>
                {makeRowColumn(
                    rowObj['FREE_POINT'],
                    usedPoint.type,
                    usedPoint.format
                )}
              </b>
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      USED_POINT: {
        makeBody: (rowObj, headsMap) => {
          const usedPoint = getHeadObj(headsMap, 'USED_POINT');
          return (
            <b style={{ color: '#f00' }}>
              {makeRowColumn(
                rowObj['USED_POINT'],
                usedPoint.type,
                usedPoint.format
              )}
            </b>
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      PREV_MONTH_USED_POINT: {
        makeBody: (rowObj, headsMap) => {
          const prevUsedPoint = getHeadObj(headsMap, 'PREV_MONTH_USED_POINT');
          return makeRowColumn(
            rowObj['PREV_MONTH_USED_POINT'],
            prevUsedPoint.type,
            prevUsedPoint.format
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      TOTAL_USED_POINT: {
        makeBody: (rowObj, headsMap) => {
          const totalUsedPoint = getHeadObj(headsMap, 'TOTAL_USED_POINT');
          return makeRowColumn(
            rowObj['TOTAL_USED_POINT'],
            totalUsedPoint.type,
            totalUsedPoint.format
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      MONTH_POINT: {
        makeBody: (rowObj, headsMap) => {
          const mothPoint = getHeadObj(headsMap, 'MONTH_POINT');
          const bMothPoint = getHeadObj(headsMap, 'BONUS_MONTH_POINT');
          return (
            <>
              {makeRowColumn(
                rowObj['MONTH_POINT'],
                mothPoint.type,
                mothPoint.format
              )}
              <br />
              <span style={{ color: '#179702' }}>보</span>
              {makeRowColumn(
                rowObj['BONUS_MONTH_POINT'],
                bMothPoint.type,
                bMothPoint.format
              )}
            </>
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      BONUS_MONTH_POINT: { merged: true },
      PREV_MONTH_POINT: {
        makeBody: (rowObj, headsMap) => {
          const mothPoint = getHeadObj(headsMap, 'PREV_MONTH_POINT');
          const bMothPoint = getHeadObj(headsMap, 'BONUS_PREV_MONTH_POINT');
          return (
            <>
              {makeRowColumn(
                rowObj['PREV_MONTH_POINT'],
                mothPoint.type,
                mothPoint.format
              )}
              <br />
              <span style={{ color: '#179702' }}>보</span>
              {makeRowColumn(
                rowObj['BONUS_PREV_MONTH_POINT'],
                bMothPoint.type,
                bMothPoint.format
              )}
            </>
          );
        },
        merged: newIsShopFlag || !onPrice,
      },
      BONUS_PREV_MONTH_POINT: { merged: true },
      SHOP_WEB: {
        makeHead: (headsMap) => {
          return t('상점') + '(WEB)';
        },
        makeBody: (rowObj, headsMap) => {
          return (
            <NewButton
              title={t('광고유무') + ' on/off'}
              icon="faPowerOff"
              iconBtn
              onClick={() => handleStateToggle(rowObj, '01')}
              style={
                rowObj.SHOP_WEB === 'Y' ? { backgroundColor: '#79bd2f' } : {}
              }
              color={rowObj.SHOP_WEB === 'Y' ? '#fff' : undefined}
            />
          );
        },
        bodyStyle: { width: 70 },
        merged: !newIsShopFlag,
      },
      SHOP_MOBILE: {
        makeHead: (headsMap) => {
          return t('상점') + '(M)';
        },
        makeBody: (rowObj, headsMap) => {
          return (
            <NewButton
              title={t('광고유무') + ' on/off'}
              icon="faPowerOff"
              iconBtn
              onClick={() => handleStateToggle(rowObj, '02')}
              style={
                rowObj.SHOP_MOBILE === 'Y' ? { backgroundColor: '#79bd2f' } : {}
              }
              color={rowObj.SHOP_MOBILE === 'Y' ? '#fff' : undefined}
            />
          );
        },
        bodyStyle: { width: 50 },
        merged: !newIsShopFlag,
      },
      GRADE: {
        makeBody: (rowObj, headsMap) => {
          return rowObj['GRADE'];
        },
        merged: newIsShopFlag || onPrice || !onGrade,
        orderFlag: false,
      },
      TOTAL_POINT: {
        makeBody: (rowObj, headsMap) => {
          const totalPoint = getHeadObj(headsMap, 'TOTAL_POINT');
          return makeRowColumn(
            rowObj['TOTAL_POINT'],
            totalPoint.type,
            totalPoint.format
          );
        },
        merged: !ctgrSeq || !onPrice,
        orderFlag: false,
      },
      TOTAL_BONUS_POINT: {
        makeBody: (rowObj, headsMap) => {
          const totalBonusPoint = getHeadObj(headsMap, 'TOTAL_BONUS_POINT');
          return (
            <>
              {makeRowColumn(
                rowObj['TOTAL_BONUS_POINT'],
                totalBonusPoint.type,
                totalBonusPoint.format
              )}
            </>
          );
        },
        merged: !ctgrSeq || !onPrice,
        orderFlag: false,
      },
      HOMEPAGE_URL: {
        makeHead: (headsMap) => {
          return t('URL');
        },
        makeBody: (rowObj, headsMap) => {
          const homepageUrl = rowObj['HOMEPAGE_URL'];
          return (
            <>
              <div
                style={{
                  width: 150,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'noWrap',
                }}
              >
                {homepageUrl}
              </div>
              {homepageUrl !== '' && (
              <NewButton
                title={t('URL 복사')}
                icon="faCopy"
                iconBtn
                onClick={() => handleCopyClipBoard(homepageUrl)}
                disableRipple
              />
              )}
            </>
          )
        },
        headStyle: { width: 150 },
        orderFlag: false,
      },
      GUBUN: {
        makeHead: (headsMap) => {
          return t('구분/권한');
        },
        makeBody: (rowObj, headsMap) => {
          let colorCode = '#000000';
          switch(rowObj['GUBUN']) {
            default: break;
            case '11': colorCode = '#70ad47'; break;
            case '12': colorCode = '#fabe00'; break;
            case '13': colorCode = '#4eb798'; break;
          }
          return (
            <>
              <span style={{ fontWeight: 'bold', color: colorCode }}>{rowObj['GUBUN_STR']}</span>
              {rowObj['GUBUN'] == '13' && rowObj['GRADE'] && (
                  <>
                    <br />
                    <span style={{ fontWeight: 'bold', color: colorCode }}>({rowObj['GRADE']})</span>
                  </>
              )}
            </>
          );
        },
      },
      GUBUN_STR: { merged: true },
    };
    setCustomized(newCustomized);
  };

  const handleStateToggle = (rowData, tpCode) => {
    setLoading(true);

    const newStateKey = tpCode === '01' ? 'SHOP_WEB' : 'SHOP_MOBILE';
    const newState = rowData[newStateKey] === 'N' ? '01' : '02';
    const newParams = {
      userId: rowData['USER_ID'],
      pltfomTpCode: tpCode,
      state: newState,
    };

    chopChange(newParams)
      .then((response) => {
        const { message } = response.data;
        setReFetch(true);
        handleClickSnackbar({ message: message, option: { type: 'success' } });
      })
      .catch((error) =>
        handleClickSnackbar({ message: error, option: { type: 'error' } })
      )
      .finally(() => setLoading(false));
  };

  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParam) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParam)
    ) {
      setInitialization(true);
      setParams(initParam);
      setTempParams(initParam);
      handleCustomized(initParam);
    }
  };

  const getTempParam = (newParams) => {
    if (
      JSON.stringify(params) !== JSON.stringify(newParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParam)
    ) {
      if (newParams.open) {
        newParams = { ...newParams, gubun: '11' };
      } else {
        delete newParams['sPoint'];
        delete newParams['ePoint'];
      }
      if (
        tempParams.contact !== newParams.contact ||
        tempParams.pid !== newParams.pid ||
        tempParams.ctgrSeq !== newParams.ctgrSeq
      ) {
        //담당자/대행사/카테고리 선택시 사용자 구분[광고주]로 필터 자동변경
        setTempParams({ ...newParams, gubun: '11', order: 'USED_POINT' });
      } else {
        setTempParams({ ...newParams, order: 'JOIN_DATE' });
      }
    }
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
      handleSetAddColumn(tempParams);
      handleCustomized(tempParams);
    }
  };

  const getParamTable = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
      setParams(newParams);
    }
  };
  const formatNumber = (value) => {
    // 숫자와 쉼표만 포함하는 문자열로 변경
    const formattedValue = value.toString();
    // 쉼표를 제거한 후 숫자로 변경
    const numericValue = Number(formattedValue.replace(/,/g, ''));
    // 세 자리마다 쉼표를 추가한 후 반환
    return numericValue.toLocaleString();
  };

  const modalGetParams = (newParams, type) => {
    if (!!newParams.payPoint) {
      newParams = { ...newParams, payPoint: formatNumber(newParams.payPoint) };
    }
    if (JSON.stringify(modal.params) !== JSON.stringify(newParams)) {
      if (!!type) {
        let tempParams = {};
        let newError = { ...error };
        newError[type] = !newParams[type];
        if (
          type === 'payPoint' ||
          type === 'reloadPoint' ||
          type === 'balancePoint' ||
          type === 'agencyFee' ||
          type === 'placeboFee'
        ) {
          newError[type] = !newParams[type];
        }
        if (type === 'restRsnCode') {
          delete newParams['rsvDate'];
          delete newParams['rsvTime'];
          delete newParams['weekType'];
          delete newParams['prePayReserve'];
          delete newParams['payLaterReserve'];
          if (
            newParams.restRsnCode === '11' ||
            newParams.restRsnCode === '13'
          ) {
            newError = {
              userId: false,
              payPoint: false,
              rsvTime: false,
            };
          } else if (newParams.restRsnCode === '04') {
            newError = { userId: false, payPoint: false, restRsnCode: false, dtlRestRsnCode: false };
          } else {
            newError = { userId: false, payPoint: false, restRsnCode: false };
          }
          setReloadEdit(false);
          setError(newError);
        }
        if (
          //보너스 충전>등록리스트
          type === 'prePayReserve' ||
          type === 'payLaterReserve'
        ) {
          let newReserveData;
          if (!!newParams.prePayReserve) {
            let newPrePayReserve = newParams.prePayReserve;
            newReserveData = newPrePayReserve.split('_');
          }
          if (!!newParams.payLaterReserve) {
            let newPayLaterReserve = newParams.payLaterReserve;
            newReserveData = newPayLaterReserve.split('_');
          }
          reserveCheck({
            userId: newParams.userId,
            date: newReserveData[0],
            time: newReserveData[1],
          })
            .then((response) => {
              const { data, parameter } = response.data;
              tempParams = {
                ...newParams,
                payPoint: formatNumber(data.point),
                rsvDate: parameter.rsvDate === '11' ? '' : parameter.rsvDate,
                rsvTime: parameter.rsvTime,
                weekType: data.week,
              };
              newError = {
                userId: false,
                payPoint: false,
                rsvDate: false,
                restRsnCode: false,
                rsvTime: false,
              };
              setModal({
                ...modal,
                confirmBtnTitle: t('삭제'),
                params: tempParams,
              });
              setModalEventType('delete');
              setDeleteParam(tempParams);
              setReloadEdit(true);
              setError(newError);
            })
            .catch((error) => {
              handleClickSnackbar({
                message: error,
                option: { type: 'error' },
              });
            });
        } else {
          setModal({
            ...modal,
            params: newParams,
            confirmBtnTitle: t('확인'),
          });
          setModalEventType('confirm');
        }
        setError(newError);
      } else {
        setModal({
          ...modal,
          params: newParams,
        });
        setModalEventType('confirm');
      }
    }
  };

  /**
   * 필터 선택 관련
   */
  const handleOnchangeFilter = (filterParam) => {
    setParams({ ...params, ...filterParam });
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const handleOnLogin = (rowData, url, type) => {
    userOnLogin(rowData['USER_ID'], type, url)
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          if (modal.type === 'rePassword') {
            window.open(data.url);
            handleModalClose();
          } else {
            handlePortalUrl(data.url);
          }
        } else {
          handleClickSnackbar({
            message: t('로그인에 실패했습니다. 관리자에게 문의하세요.'),
            option: { type: 'error' },
          });
        }
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
  };

  const handleModalOpen = (rowObj, type) => {
    let newModal = { ...modal, open: true, type: type };
    let newError = {};
    if (type === 'rePassword') {
      newError = { password: false };
      newModal = {
        ...newModal,
        gubun: rowObj.GUBUN,
        params: { userId: rowObj.USER_ID, password: '' },
        modalTitle: t('비밀번호 확인'),
      };
      setModal(newModal);
    } else {
      chargeAuthCheck({ userId: rowObj.USER_ID })
        .then((response) => {
          newError = { ...initError };
          const { data } = response.data;
          newModal = {
            ...newModal,
            params: {
              ...rowObj,
              userId: rowObj.USER_ID,
              setleUserId: user.userid,
              date: '',
              payPoint: '',
              name: '',
            },
            agencyList: data.agency,
            prePayReserveList: data.prePayReserve,
            payLaterReserveList: data.payLaterReserve,
            modalTitle: t('충전 관리'),
          };
          setError(newError);
          setModal(newModal);
        })
        .catch((error) => {
          handleClickSnackbar({ message: error, option: { type: 'error' } });
        });
    }
  };

  const handleModalClose = () => {
    let newModal = { ...modal };
    newModal = { ...newModal, open: false };
    setModal(newModal);
    setError({});
  };

  const handleSubmit = (eType) => {
    const { type } = modal;

    let newParams = {};
    if (modal['params'].dealType === '03') {
      delete error['agency'];
    }
    if (modal['params'].rsvDate === '') {
      delete error['rsvDate'];
    }
    let validator = Validator(paramConverter(modal['params']), error);
    if (validator['state']) {
      handleClickSnackbar({
        message: t('필수값을 확인해주세요.'),
        option: { type: 'error' },
      });
      setError(validator['validate']);
    } else {
      if (type === 'rePassword') {
        const domainLocation = {
          'https://admfe4.mobon.net': 'https://mbs4.mobon.net/main',
          'https://admfe5.mobon.net': 'http://mbsdev5.mobon.net/main',
          'default': 'https://mobsense.mobon.net/main',
        };
        let loginType;
        let devLocation;
        if (modal['gubun'] === '13') {
          loginType = 'mobsense';
          devLocation =
            domainLocation[window.origin] || domainLocation['default'];
        } else {
          loginType = 'manage';
          if (window.origin === 'https://admfe4.mobon.net') {
            devLocation = 'https://mac4.mobon.net';
          } else {
            devLocation = 'https://adcenter.mobon.net';
          }
        }
        const adverShowWindowUrl = converParameters({
          url: devLocation + '/cookieLogin?userId='+modal.params.userId,
        });
        checkPassword(modal.params)
          .then((response) => {
            handleOnLogin(
              { USER_ID: modal.params.userId },
              adverShowWindowUrl,
              loginType
            );
          })
          .catch((error) => {
            handleClickSnackbar({ message: error, option: { type: 'error' } });
          });
      } else if (
        type === 'prePay' ||
        type === 'payLater' ||
        type === 'payRefund' ||
        type === 'cardRefund' ||
        type === 'tossPayRefund' ||
        type === 'tossCardRefund'
      ) {
        newParams = {
          userId: modal.params.userId,
          setleUserId: user.userid,
          payPoint: !!modal.params.reloadPoint
            ? Number(modal.params.reloadPoint.replace(/,/g, ''))
            : Number(modal.params.payPoint.replace(/,/g, '')),
          name: modal.params.name,
          modiDate: modal.params.date,
          agency: modal.params.dealType !== '03' ? modal.params.agency : null,
          balancePoint: Number(modal.params.balancePoint.replace(/,/g, '')),
          agencyFee: modal.params.agencyFee,
          placeboFee: modal.params.placeboFee,
          dealType: modal.params.dealType,
          pointType: type,
        };
        deposit(newParams)
          .then((response) => {
            handleClickSnackbar({
              message: response.data.message,
              option: { type: 'success' },
            });
          })
          .catch((error) => {
            handleClickSnackbar({ message: error, option: { type: 'error' } });
          })
          .finally(() => {
            setReloadEdit(false);
            handleModalClose();
          });
      } else if (type === 'reload') {
        if (eType !== 'delete') {
          newParams = {
            userId: modal.params.userId,
            reload: modal.params.reload,
            payPoint: Number(modal.params.payPoint.replace(/,/g, '')),
            restRsnCode: modal.params.restRsnCode,
            dtlRestRsnCode: modal.params.dtlRestRsnCode,
            rsvDate: modal.params.rsvDate,
            rsvTime: modal.params.rsvTime,
            weekType: modal.params.weekType,
            memo: modal.params.memo,
          };
          if (!reloadEdit) {
            chargeBonus(newParams)
              .then((response) => {
                handleClickSnackbar({
                  message: response.data.message,
                  option: { type: 'success' },
                });
              })
              .catch((error) => {
                handleClickSnackbar({
                  message: error,
                  option: { type: 'error' },
                });
              })
              .finally(() => {
                setReloadEdit(false);
                handleModalClose();
              });
          } else {
            chargeBonusEdit(newParams)
              .then((response) => {
                handleClickSnackbar({
                  message: response.data.message,
                  option: { type: 'success' },
                });
              })
              .catch((error) => {
                handleClickSnackbar({
                  message: error,
                  option: { type: 'error' },
                });
              })
              .finally(() => {
                setReloadEdit(false);
                handleModalClose();
              });
          }
        } else {
          newParams = {
            userId: deleteParam.userId,
            payPoint: deleteParam.payPoint,
            restRsnCode: deleteParam.restRsnCode,
            rsvTime: deleteParam.rsvTime,
            weekType: deleteParam.weekType,
          };
          if (!!deleteParam.rsvDate) {
            newParams = { ...newParams, rsvDate: deleteParam.rsvDate };
          }
          chargeBonusDelete(newParams)
            .then((response) => {
              handleClickSnackbar({
                message: response.data.message,
                option: { type: 'success' },
              });
            })
            .catch((error) => {
              handleClickSnackbar({
                message: error,
                option: { type: 'error' },
              });
            })
            .finally(() => {
              setReloadEdit(false);
              handleModalClose();
            });
        }
      }
    }
  };

  const handleCur = (cur) => {
    let newParams = { ...modal.params };
    let newModal = { ...modal };
    let newError = {};
    newParams = {
      ...newParams,
      payPoint: '',
      reloadPoint: '',
      balancePoint: '',
      agencyFee: '',
      placeboFee: '',
    };
    delete newParams['dealType'];
    delete newParams['agency'];

    if (cur === 'prePay' || cur === 'payLater') {
      newParams = { ...newParams, payPoint: '' };
      newError = { userId: false, payPoint: false, name: false, date: false };
      newModal = { ...modal, confirmBtnTitle: t('확인') };
    } else if (
      cur === 'payRefund' ||
      cur === 'cardRefund' ||
      cur === 'tossPayRefund' ||
      cur === 'tossCardRefund'
    ) {
      newParams = {
        ...newParams,
        reloadPoint: '',
        balancePoint: '',
        agencyFee: '0',
        placeboFee: '0',
      };
      newModal = { ...modal, confirmBtnTitle: t('확인') };
      newError = {
        reloadPoint: false,
        balancePoint: false,
        agencyFee: false,
        placeboFee: false,
        dealType: false,
        date: false,
        agency: false,
      };
    } else if (cur === 'reload') {
      newParams = {
        ...newParams,
        reloadPoint: '',
        balancePoint: '',
        agencyFee: '0',
        placeboFee: '0',
        rsvDate: '',
        rsvTime: '',
        weekType: '',
        prePayReserve: '',
        payLaterReserve: '',
        restRsnCode: '',
        dtlRestRsnCode: '',
      };
      newError = { userId: false, payPoint: false, restRsnCode: false };
    }
    setModal({ ...newModal, open: true, params: newParams, type: cur });
    setModalEventType('confirm');
    setReloadEdit(false);
    setError(newError);
  };

  let tableTitle = '';
  if (tableListCount.adverCnt !== 'undefined') {
    tableTitle =
      t('광고주 현황') +
      ' : ' +
      numeral(tableListCount.adverCnt).format() +
      ' / ' +
      numeral(tableListCount.totalAdverCnt).format();
  }

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);
  return (
    <MainTemplate loading={loading}>
      <MainContentTemplate>
        <NewFilterWrap handleOnReset={handleOnReset}>
          <FilterCollection
            label={t('사용자 정보')}
            value={tempParams.shopFlag}
            name="shopFlag"
            type="radio"
            params={tempParams}
            list={[
              { label: t('전체'), value: 'all' },
              { label: t('상점'), value: '1' },
            ]}
            labelKey="label"
            valueKey="value"
            callBack={getTempParam}
          />
          <FilterCollection
            label={t('사용자 구분')}
            value={tempParams.gubun}
            name="gubun"
            type="radio"
            params={tempParams}
            list={[
              { label: t('전체'), value: 'all' },
              { label: t('광고주'), value: '11' },
              { label: t('파트너'), value: '12' },
              { label: t('매체'), value: '13' },
            ]}
            labelKey="label"
            valueKey="value"
            callBack={getTempParam}
            disabled={!!tempParams.shopFlag && tempParams.shopFlag !== 'all'}
          />
          <NewCommonFilter
            initialization={initialization}
            getParam={getTempParam}
            params={tempParams}
            usePltfomTpCodeFilter={false}
            useExternalFilter={false}
            useDisplayFilter={false}
            useManagerFilter={
              !!tempParams.shopFlag && tempParams.shopFlag === 'all'
            }
            dateLabel={t('지출금액 범위')}
            disabled={!!tempParams.shopFlag && tempParams.shopFlag !== 'all'}
          />
          <FilterCollection
            label={t('광고주 대행사')}
            value={tempParams.pid}
            name="pid"
            type="select"
            params={tempParams}
            list={newAgencyMenus}
            labelKey="CORP_NAME"
            valueKey="USER_ID"
            callBack={getTempParam}
            disabled={!!tempParams.shopFlag && tempParams.shopFlag !== 'all'}
          />
          <FilterCollection
            label={t('매체 신디사')}
            value={tempParams.userId}
            name="userId"
            type="select"
            params={tempParams}
            list={newSindyMenus}
            labelKey="CORP_NAME"
            valueKey="USER_ID"
            callBack={getTempParam}
            disabled={!!tempParams.shopFlag && tempParams.shopFlag !== 'all'}
          />
          <FilterCollection
              label={t('상태')}
              value={tempParams.eventState}
              name="eventState"
              type="radio"
              params={tempParams}
              list={[
                { label: t('전체'), value: 'all' },
                { label: t('라이브'), value: '01' },
                { label: t('중지'), value: '02' },
              ]}
              labelKey="label"
              valueKey="value"
              callBack={getTempParam}
              disabled={!!tempParams.shopFlag && tempParams.shopFlag !== 'all'}
          />
          <NewRemainingAmountFilter
            initialization={initialization}
            handleOnchangeFilter={handleOnchangeFilter}
            getParam={getTempParam}
            params={tempParams}
            label={t('잔여금액')}
            disabled={!!tempParams.shopFlag && tempParams.shopFlag !== 'all'}
          />
          <NewCategoryFilter
            params={tempParams}
            getParam={getTempParam}
            disabled={!!tempParams.shopFlag && tempParams.shopFlag !== 'all'}
          />
          <NewButton
            title={t('검색')}
            disableRipple
            className={classes.submitBtnWrap}
            onClick={getParam}
          >
            {t('검색')}
          </NewButton>
        </NewFilterWrap>
        {addColumnList.size !== 0 && (
          <NewTableContainer
            title={tableTitle}
            params={params}
            getParam={getParamTable}
            dataReqPromise={members}
            customized={customized}
            useTotal={false}
            addColumnList={addColumnList}
            reFetchHead
            reFetch={reFetch}
            useSearch={!modal.open}
            dataCallBack={(newCnt) => {
              setTableListCount(newCnt);
            }}
          />
        )}
        <Modal
          open={modal.open}
          headerTitle={modal.modalTitle}
          handleClose={handleModalClose}
          confirmBtnTitle={modal.confirmBtnTitle}
          cancelBtnOpen={modal.cancelBtnOpen}
          cancelBtnTitle={modal.cancelBtnTitle}
          confirmOnClick={(e) => handleSubmit(modalEventType)}
        >
          {modal.type === 'rePassword' ? (
            <NewInput
              type="filter"
              inputType="password"
              name="password"
              params={modal.params}
              value={modal.params.password}
              callBack={modalGetParams}
              autoFocus
              error={error.password}
              helperText={!!error.password && t('비밀번호를 입력해주세요.')}
            />
          ) : (
            <MbTabs
              isMenuTab={false}
              name="UsersModal"
              initValue="prePay"
              getCurTab={(cur) => {
                handleCur(cur);
              }}
              tabMenuList={(() => {
                const result = new Map();
                result.set('prePay', {
                  menuUrl: 'prePay',
                  menuSeq: 'prePay',
                  menuNm: t('무통장입금'),
                });
                result.set('payLater', {
                  menuUrl: 'payLater',
                  menuSeq: 'payLater',
                  menuNm: '후불',
                });
                result.set('payRefund', {
                  menuUrl: 'payRefund',
                  menuSeq: 'payRefund',
                  menuNm: '환불',
                });
                result.set('cardRefund', {
                  menuUrl: 'cardRefund',
                  menuSeq: 'cardRefund',
                  menuNm: '카드환불',
                });
                result.set('tossCardRefund', {
                  menuUrl: 'tossCardRefund',
                  menuSeq: 'tossCardRefund',
                  menuNm: (
                      <>
                        토스환불<br />
                        (신용카드)
                      </>
                  ),
                });
                result.set('tossPayRefund', {
                  menuUrl: 'tossPayRefund',
                  menuSeq: 'tossPayRefund',
                  menuNm: (
                      <>
                        토스환불<br />
                        (토스머니)
                      </>
                  ),
                });
                return result;
              })()}
              tabs={{
                prePay: {
                  tabComponent: (
                    <ChargeBox
                      chargingType="prePay"
                      modal={modal}
                      params={modal.params}
                      getParams={modalGetParams}
                      error={error}
                    />
                  ),
                },
                payLater: {
                  tabComponent: (
                    <ChargeBox
                      chargingType="payLater"
                      modal={modal}
                      params={modal.params}
                      getParams={modalGetParams}
                      error={error}
                    />
                  ),
                },
                payRefund: {
                  tabComponent: (
                    <ChargeBox
                      chargingType="payRefund"
                      modal={modal}
                      params={modal.params}
                      getParams={modalGetParams}
                      error={error}
                    />
                  ),
                },
                cardRefund: {
                  tabComponent: (
                    <ChargeBox
                      chargingType="cardRefund"
                      modal={modal}
                      params={modal.params}
                      getParams={modalGetParams}
                      error={error}
                    />
                  ),
                },
                tossPayRefund: {
                  tabComponent: (
                    <ChargeBox
                      chargingType="tossPayRefund"
                      modal={modal}
                      params={modal.params}
                      getParams={modalGetParams}
                      error={error}
                    />
                  ),
                },
                tossCardRefund: {
                  tabComponent: (
                    <ChargeBox
                      chargingType="tossCardRefund"
                      modal={modal}
                      params={modal.params}
                      getParams={modalGetParams}
                      error={error}
                    />
                  ),
                },
              }}
              isModal={true}
            />
          )}
        </Modal>
      </MainContentTemplate>
    </MainTemplate>
  );
};

export default UserList;
